__turbopack_context__.v({
  "addCartBtn": "product-grid-module__Bn7CPW__addCartBtn",
  "productCard": "product-grid-module__Bn7CPW__productCard",
  "productGrid": "product-grid-module__Bn7CPW__productGrid",
  "productImagePlaceholder": "product-grid-module__Bn7CPW__productImagePlaceholder",
  "productInfo": "product-grid-module__Bn7CPW__productInfo",
  "productName": "product-grid-module__Bn7CPW__productName",
  "productPrice": "product-grid-module__Bn7CPW__productPrice",
});
